import { State, StateView } from 'components';
import { useVerifyMail } from 'hooks';
import { FC, useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { isEmptyOrNull } from 'utils';

const successMessages = [
  'Prima, deine E-Mail ist bestätigt.',
  'Wir freuen uns auf deine Beiträge!'
];

const errorMessages = ['Ups, etwas ist schiefgelaufen!'];

export const EmailConfirmation: FC = () => {
  const [searchParams] = useSearchParams();

  const personId = searchParams.get('person') ?? undefined;
  const mailToken = searchParams.get('token') ?? undefined;

  const { mutate: verifyEmail } = useVerifyMail();

  const [state, setState] = useState<State>(State.Loading);
  const [messages, setMessages] = useState<string[]>();

  const handleVerifyEmail = useCallback(() => {
    if (mailToken && personId) {
      verifyEmail(
        {
          mailToken,
          clientPersonVerifyEmailAddressRequest: { personId }
        },
        {
          onError: () => {
            setState(State.Error);
            setMessages(errorMessages);
          },
          onSuccess: () => {
            setState(State.Success);
            setMessages(successMessages);
          }
        }
      );
    }
  }, [mailToken, personId, verifyEmail]);

  useEffect(() => {
    if (!isEmptyOrNull(personId) && !isEmptyOrNull(mailToken)) {
      handleVerifyEmail();
    } else {
      setState(State.Error);
      setMessages(errorMessages.concat(['MISSING_OR_INVALID_QUERY_PARAM']));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personId, mailToken]);

  return <StateView state={state} messages={messages} />;
};
